import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import servicesData from "../services.json";
import contentConfig from "../content.config.json";

import "../Styles/Services.css";

const Services = () => {
  const categories = Object.keys(servicesData);

  return (
    <div className="services-page page-shell">
      <section className="page-hero">
        <div className="page-hero-inner">
          <span className="section-badge">What We Offer</span>
          <h1 className="page-hero-title">{contentConfig.services.title}</h1>
          <p className="page-hero-subtitle">{contentConfig.services.subtitle}</p>
        </div>
      </section>

      <div className="services-container">
        <div className="services-categories">
          {categories.map((category, index) => (
            <section key={index} className="service-category-section">
              <header className="category-header">
                <span className="category-index">
                  {String(index + 1).padStart(2, "0")}
                </span>
                <h2 className="category-title">{category}</h2>
              </header>

              <div className="services-grid">
                {servicesData[category].map((service) => {
                  if (service.details) {
                    return (
                      <Link
                        key={service.slug}
                        to={`/services/${service.slug}`}
                        className="service-card service-card--clickable"
                      >
                        <span className="service-name">{service.name}</span>
                        <FaArrowRight className="service-arrow" />
                      </Link>
                    );
                  }

                  return (
                    <div key={service.slug} className="service-card">
                      <span className="service-name">{service.name}</span>
                    </div>
                  );
                })}
              </div>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services;
